import { getGraphHeaders } from '@/utils/getGraphHeaders';
import { logWarning } from '@/utils/miscUtils';
import { BffBrandType } from '@/types/generated';
import { cacheFn } from '@/utils/cacheFn/cacheFn';

export const getBffFacilityById = cacheFn(
	async (brand: BffBrandType, id: string, url: string, appName: string, appVersion: string) => {
		try {
			if (!brand) {
				return null;
			}
			const { getGraphQLClient } = await import(
				/* webpackChunkName:"getGraphQLClient" */ '../graphql/getGraphQLClient'
			);
			return await getGraphQLClient(url).bffFacilityById(
				{
					brand,
					id,
				},
				getGraphHeaders(appName, appVersion)
			);
		} catch (err) {
			logWarning(`Could not find any facilities data for: ${brand} for query: ${id}`);
		}
	}
);
